<template>
	<v-row class="ma-0 pa-0 pr-10 mt-5" align="center" style="font-size:0.8rem">
		<v-col class="ma-0 pa-0" cols="1">{{ta('weatherForecast')}}</v-col>
		<template v-if="weatherLoading">
			<v-col class="ma-0 pa-0" cols="11">
				<v-row class="ma-0 pa-0 pl-2 pr-7" align="center" justify="space-around">
					<v-col class="ma-0 pa-0" cols="auto" align="center"
						v-for="item in axisNum" :key="item">
						<v-skeleton-loader :boilerplate="false" elevation="0" dark 
							type="image" width="4.5rem" height="55.5px"
						></v-skeleton-loader>
					</v-col>
				</v-row>
			</v-col>
		</template>
		<template v-else>
			<v-col class="ma-0 pa-0" cols="11">
				<v-row class="ma-0 pa-0 pl-2 pr-7" align="center" justify="space-around">
					<template v-if="mode == 'hour'">
						<v-col v-for="(item, index) in weatherDate" :key="index" 
							class="ma-0 pa-0 pl-3 temp" cols="auto" align="center">
							<img class="ma-0 pa-0" width="65" height="32.5"
								:src="require('@/assets/weather/icon_weather_' + item.weather_cd + '00' + '.svg')"  alt=""> <br>
							{{item.temperature}} ℃
						</v-col>
					</template>
					<template v-if="mode == 'day'">
						<v-col v-for="(item, index) in weatherDate" :key="index" 
							class="ma-0 pa-0 pl-1 temp" cols="auto" align="center">
							<img class="ma-0 pa-0" width="65" height="32.5"
								:src="require('@/assets/weather/icon_weather_' + item.weather_cd + '.svg')"  alt=""> <br>
							{{item.max_temperature}} / {{item.min_temperature}} ℃
						</v-col>
					</template>
				</v-row>
			</v-col>
		</template>
	</v-row>
</template>

<script>
import mixin from '@/mixin';
export default {
	props: {
		weatherLoading: { type: Boolean, default: false },
		mode: { type: String },
		axisNum: { type: Number },
		weatherDate: { type: Array, default: [] },
	},
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
		
	}),
	methods: {
		ta(t) {
      return this.$t("lang.allStoreAnalytics." + t);
    },
	}
}
</script>

<style lang="scss" scoped>
.temp {
	font-size: 0.75rem;
}
</style>